import { GenericObject } from "./types";

/**
 * Determins if the target contians any values
 */
export function isPopulated<T extends GenericObject<any> = GenericObject<any>>(target: T): boolean {
	if (typeof target !== 'object') return false;

	if (Array.isArray(target)) {
		return target.length > 0;
	}

	for (const key in target) return true;

	return false
}